import BedLinensSection from './BedLinensSection';

export default BedLinensSection;
